import { useAutoSync, useReactOnSyncChange } from 'features/messaging/hooks'

import { api } from '../../api'
import { useIsAvailable } from '../../hooks/useIsAvailable'
import css from './UnreadCount.module.css'

export const UnreadCountView = ({ count }: { count?: number }) =>
	Boolean(count) && <span className={css.count}>{count}</span>

export function UnreadCount() {
	const options = useAutoSync()

	const isMessageAvailable = useIsAvailable()

	const { currentData, isSuccess, refetch } = api.useUnreadQuery(undefined, {
		...options,
		skip: !isMessageAvailable
	})

	useReactOnSyncChange(isMessageAvailable && refetch)

	if (isMessageAvailable && isSuccess) {
		return <UnreadCountView count={currentData?.inbox} />
	}

	return null
}
